// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--1YasI","contactContainer":"layout-module--contactContainer--XaAiS","content":"layout-module--content--tWALU"};